var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelSvgrepoPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51807 13.7201C8.22767 14.1978 9.08133 14.4771 9.99927 14.4771C12.4551 14.4771 14.4531 12.479 14.4531 10.0232C14.4531 9.10526 14.1739 8.25159 13.6961 7.54199L7.51807 13.7201Z",
    fill: "#C43232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99928 5.56934C7.54334 5.56934 5.54541 7.56727 5.54541 10.0232C5.54541 11.0629 5.90434 12.0196 6.50368 12.7783L12.7542 6.52774C11.9957 5.92827 11.0389 5.56934 9.99928 5.56934Z",
    fill: "#C43232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 0C4.477 0 0 4.4774 0 9.9998C0 15.5222 4.477 20 9.9996 20C15.5222 20 19.9996 15.5225 19.9996 9.9998C19.9996 4.47713 15.5223 0 9.9996 0ZM9.9998 15.8605C6.78113 15.8605 4.16267 13.2418 4.16267 10.0233C4.16267 6.80467 6.78113 4.1862 9.9998 4.1862C13.2183 4.1862 15.8369 6.80467 15.8369 10.0233C15.8369 13.2418 13.2183 15.8605 9.9998 15.8605Z",
    fill: "#C43232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSvgrepoPickup);
export default __webpack_public_path__ + "static/media/cancel-svgrepo-pickup.a1026fd9.svg";
export { ForwardRef as ReactComponent };